import React, { useState, useEffect, useContext } from "react";
import Sidebar from "../../components/sidebar/sidebar";
import "./room.css";
import Topbar from "../../components/topbar/topbar";
import { columns } from "./columns.jsx";
import Content from "../../components/room/addroom/indexAddRoom";
import MUIDataTable from "mui-datatables";
import Fontawesome from "../../components/fontawesome/fontawesome";
import { useFetch } from "../../components/hooks/useFetch";
import { Prefix } from "../../services/prefix";
import Loading from "../../components/loader/loading";
import api from "../../services/api";
import Swal from "sweetalert2";
import CustomSearchRender from "../../components/customSearchRender/CustomSearchRender";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import CustomFooter from "../../components/CustomFooter/CustomFooter";
import { Card, Row, Col, Table } from "react-bootstrap";
import FilterRoom from "../../components/room/filter/filterRoom";
import { Context } from "../../services/context";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { GetMuiTheme } from "../../components/muiTheme/muiTheme";
import {
  CardSt,
  CardHeaderSt,
  IconTitleSt,
  TitleSt,
  TextTitleSt,
  SmallTitleSt,
} from "../../style/globalStyle";

export const Room = () => {
  const {
    selectclient,
    selectunit,
    selectsector,
    setSelectClient,
    setSelectUnit,
    setSelectSector,
  } = useContext(Context);

  useEffect(() => {
    setSelectClient("");
    setSelectUnit("");
    setSelectSector("");
  }, []);

  const [loader, setLoader] = useState();
  const [pagina, setPagina] = useState(0);
  const [perPage, setPerPage] = useState(15);
  const [search, setSearch] = useState("");
  const [orderBy, setOrderBy] = useState("id");
  const [order, setOrder] = useState("desc");

  let pageExact = pagina + parseInt(1);

  const roomList = useFetch(
    Prefix.replace(/[\\"]/g, "") +
      "/rooms?per_page=" +
      perPage +
      "&page=" +
      pageExact +
      "&id_customer=" +
      selectclient +
      "&id_unit=" +
      selectunit +
      "&id_sector=" +
      selectsector +
      "&order_by=" +
      orderBy +
      "&order=" +
      order
  );

  const dataList = roomList.data?.models;

  const options = {
    filterType: "checkbox",
    draggableColumns: {
      enabled: true,
    },
    sortOrder:{ 
      name: orderBy, 
      direction: order, 
    },
    filter: false,
    serverSide: true,
    onTableChange: (action, tableState) => {
      setOrderBy(
        !tableState.sortOrder.name ? orderBy : tableState.sortOrder.name,
      );
      setOrder(
        !tableState.sortOrder.direction
          ? order
          : tableState.sortOrder.direction,
      );
      setPagina(tableState.page);
      setPerPage(tableState.rowsPerPage);
    },
    onSearchChange: (searchText) => {
      setSearch(!searchText ? "" : searchText);
    },
    customSearchRender: () => {
      return <FilterRoom />;
    },
    filter: false,
    page: pagina,
    count: dataList?.total,
    expandableRows: true,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    rowsPerPage: perPage,
    rowsPerPageOptions: [15, 30, 100],
    isRowExpandable: (dataIndex, expandedRows) => {
      //  if (dataIndex === 3 || dataIndex === 4) return false; Desativa a 3º e 4º linha
      if (
        expandedRows.data.length > 4 &&
        expandedRows.data.filter((d) => d.dataIndex === dataIndex).length === 0
      )
        return false;
      return true;
    },
    renderExpandableRow: (rowData, rowMeta) => {
      const colSpan = rowData.length + 1;
      return (
        <TableRow>
          <TableCell colSpan={colSpan}>
            <Row>
              <Col className="text-center">
                <h4>Dados da Sala</h4>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Endereço:</th>
                      <th>Nº:</th>
                      <th>Bairro:</th>
                      <th>Cidade:</th>
                      <th>Estado:</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td> {rowData[6]}</td>
                      <td> {rowData[8]}</td>
                      <td> {rowData[7]}</td>
                      <td> {rowData[9]}</td>
                      <td> {rowData[10]}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </TableCell>
        </TableRow>
      );
    },

    onRowsDelete: (rowsDeleted, newData) => {
      HandleDelete(rowsDeleted.data);
    },

    searchPlaceholder: "Pesquise uma sala",
    selectableRows: "multiple",

    searchOpen: true,

    textLabels: {
      body: {
        noMatch: "Desculpe, não encontramos salas!",
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `Sort for ${column.label}`,
      },
      pagination: {
        next: "Avançar",
        previous: "Voltar",
        rowsPerPage: "Linhas por página:",
        displayRows: "de",
      },

      toolbar: {
        search: "Pesquisar",
        downloadCsv: "Baixar CSV",
        print: "Imprimir",
        viewColumns: "Ver Colunas",
        filterTable: "Filtrar tabela",
      },
      filter: {
        all: "Tudo",
        title: "FILTROS",
        reset: "RESETAR",
      },
      viewColumns: {
        title: "Exibir colunas",
        titleAria: "Exibir/Ocultar colunas da tabela",
      },
      selectedRows: {
        text: "Coluna(s) selecionada(s)",
        delete: "Excluir",
        deleteAria: "Excluir linhas selecionadas",
      },
    },
    customFooter: (
      count,
      page,
      rowsPerPage,
      changeRowsPerPage,
      changePage,
      textLabels
    ) => {
      let numberPages = dataList?.last_page;
      let rowsPerPageOptions = [15, 30, 100];
      return (
        <CustomFooter
          page={page}
          rowsPerPage={rowsPerPage}
          changeRowsPerPage={changeRowsPerPage}
          changePage={changePage}
          numberPages={numberPages}
          rowsPerPageOptions={rowsPerPageOptions}
        />
      );
    },
  };
  function HandleDelete(e) {
    setLoader(<Loading />);
    let idArr = [];
    e.map((del) => {
      idArr.push(
        dataList?.data.filter((filtro, index) => index == del.index)[0].id
      );
    });

    idArr.map((idDel) =>
      api
        .delete(Prefix.replace(/[\\"]/g, "") + "/rooms/" + idDel)
        .then((response) => {
          Swal.fire({
            icon: "success",
            title: "Uow!",
            text: response.data.message,
            confirmButtonText: "Fechar",
          });
          setLoader();
          roomList.mutate();
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: err.response.data.message,
            confirmButtonText: "Tentar novamente",
          });
          setLoader();
        })
    );
  }

  return (
    <div className="wrapper d-flex align-items-stretch">
      <Sidebar />
      {loader}
      <div id="content">
        <Topbar />
        <div className="content_all">
          <CardSt>
            <CardHeaderSt>
              <TitleSt className="d-flex justify-content-between">
                <div className="d-flex justify-content-between">
                  <IconTitleSt src="../../../media/icons/base.svg" />
                  <TextTitleSt>
                    Sala <SmallTitleSt>Gestão de Salas</SmallTitleSt>
                  </TextTitleSt>
                </div>
              </TitleSt>
            </CardHeaderSt>
            <CardSt.Body as="div">
              <CardSt.Text as="div">
                <MuiThemeProvider theme={GetMuiTheme()}>
                  <MUIDataTable
                    data={dataList?.data}
                    columns={columns}
                    options={options}
                  />
                </MuiThemeProvider>
              </CardSt.Text>
            </CardSt.Body>
          </CardSt>
          <Content
            titleLabel="Adicionar Sala"
            buttonLabel="Adicionar"
            iconClass="fas fa-plus-circle"
            pageExact={pageExact}
            perPage={perPage}
            search={search}
            orderBy={orderBy}
            order={order}
          />
        </div>
      </div>
    </div>
  );
};

export default Room;
